import * as React from "react";
import clsx from "clsx";
import { useField } from "formik";

type FormikTextareaFieldProps = {
  label: string;
  name: string;
  placeholder?: string;
  helpText?: string;
  rows?: number;
  size?: "default" | "lg" | "sm";
  autoComplete?: "off" | "on" | "email";
};

function FormikTextareaField(props: FormikTextareaFieldProps) {
  const {
    name,
    label,
    placeholder = "",
    helpText = "",
    rows = 5,
    size = "default",
    autoComplete = "off",
  } = props;
  const id = `id-${name}`;
  const [field, meta] = useField(name);
  const hasError = meta.error && meta.touched;
  return (
    <div className={clsx("form-group", hasError && "has-error")}>
      <label htmlFor={id} className="label">
        {label}
      </label>
      <textarea
        id={id}
        {...field}
        className={clsx(
          "form-control",
          size !== "default" && `form-control-${size}`
        )}
        rows={rows}
        placeholder={placeholder}
        autoComplete={autoComplete}
      />
      {helpText && <div className="help-text">{helpText}</div>}
      {hasError && <div className="error-message">{meta.error}</div>}
    </div>
  );
}

export default FormikTextareaField;
